import { render, staticRenderFns } from "./ShowProviderFamily.vue?vue&type=template&id=208034ae"
import script from "./ShowProviderFamily.vue?vue&type=script&lang=js"
export * from "./ShowProviderFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports